import request from '@/plugin/axios'
import { cookieGet } from '@/common/cookie'



export const upload_pictureofsystem =  process.env.VUE_APP_API+'/v1/upload/pictureofsystem'

export const upload_videoofsystem =  process.env.VUE_APP_API+'/v1/upload/videoofsystem'

export const upload_apk = process.env.VUE_APP_API+'/v1/upload/apk'

/**
 * @description [ central ] 对接中控相关
 */
export const centralService = {
  /**
   * 查询单品(去中控取单品数据)
   * @param {String} search 要搜索的barcode 或 hint
   * @returns 
   */
  getFromCentral(search) {
    return request({
        url: '/v3/product/item/search/merchant',
        method: 'GET',
        params: {
            channel: 'APP',
            search
        }
    })
  },

  /**
   * 从中控添加单品
   * @param {String} search 要搜索的barcode 或 hint
   * @returns 
   */
  addFromCentral(data) {
    return request({
        url: '/v3/product/merge/merchant',
        method: 'POST',
        data: {
            ...data,
            noQs: true
        }
    })
  }
}

/**
 * @description [ sys ] 登陆注销相关
 */
export const sysAccountService = {
  /**
   * 登录
   */
  login (data) {
    return request({
      url: '/v1/admin/login2',
      method: 'post',
      data
    })
  }
}


/**
 * @description [ home ] 首页相关
 */
export const homeService = {
  /**
   * 今日交易额
   */
  todayTransMoney () {
    return request({
      url: '/v1/report/todaytransmoney/manager'
    })
  },

  /**
   * 今日交易笔数
   */
  todayTransCount () {
    return request({
      url: '/v1/report/todaytranscount/manager'
    })
  },

  /**
   * 今日新用户数
   */
  todayNewClientCount () {
    return request({
      url: '/v1/report/todaynewclientcount/manager'
    })
  },

  /**
   * 所有用户数
   */
  totalClientCount () {
    return request({
      url: '/v1/report/totalclientcount/manager'
    })
  },

  /**
   * 总交易额
   */
  totalTransMoney () {
    return request({
      url: '/v1/report/totaltransmoney/manager'
    })
  },

  /**
   * 30日交易额
   */
  monthTransMoney () {
    return request({
      url: '/v1/report/monthtransmoney/manager'
    })
  },  

  /**
   * 待发货订单数
   */
  waitSendCount () {
    return request({
      url: '/v1/report/waitsendcount/manager'
    })
  }, 

  /**
   * 退款申请数
   */
  refundCount () {
    return request({
      url: '/v1/report/refundcount/manager'
    })
  },  

  /**
   * 待确认数
   */
  waitingConfirmCount () {
    return request({
      url: '/v1/report/waitconfirm/manager'
    })
  },  

  /**
   * 库存预警
   */
  inventoryWarnCount () {
    return request({
      url: '/v1/report/inventoryWarnCount/manager'
    })
  },  

  /**
   * 修改预警默认值
   */
  modifyInventoryWarn (data) {
    return request({
      url: '/v1/report/inventoryWarnCountAlter/manager',
      method: 'put',
      data
    })
  },

  /**
   * 获取预警默认时间和默认预警值
   */
  getWarnQueryTime () {
    return request({
      url: '/v1/report/showInventoryWarnQueryTime/manager',
      method: 'get',
    })
  },

}


/**
 * @description [ charts ] 系统信息
 */
export const chartsService = {
  /**
   * 查询用户每日注册量
   */
  userDaysRegister (params) {
    return request({
      url: '/v1/charts/user/day/manager',
      params
    })
  },

  /**
   * 查询用户每月注册量
   */
  userMonthsRegister (params) {
    return request({
      url: '/v1/charts/user/month/manager',
      params
    })
  },

  /**
   * 查询每月订单量
   */
  userMonthsOrder (params) {
    return request({
      url: '/v1/charts/order/month/manager',
      params
    })
  },

}


/**
 * @description [ order ] 订单
 */
export const orderService = {

  /**
   * 查询总数
   */
  queryCount (params) {
    return request({
      url: '/v1/order/manager',
      params
    })
  },

  /**
   * 查询
   */
  query (params) {
    return request({
      url: '/v1/order/manager',
      params
    })
  },

  /**
   * 查询
   */
  queryOne (orderId) {
    return request({
      url: '/v1/order/detail/manager',
      params: {orderId: orderId}
    })
  },

  /**
   * 查询文案
   */
  queryFeedbackTemplate (orderId) {
    return request({
      url: '/v1/order/feedback/content',
      params: {orderId: orderId}
    })
  },

  /**
   * 确认订单
   */
  confirm (data) {
    return request({
      url: '/v1/order/confirm',
      method: 'post',
      data
    })
  },

  /**
   * 确认已收货
   */
  markReceived (data) {
    return request({
      url: '/v1/order/receipted/manager',
      method: 'post',
      data
    })
  },

  /**
   * 修改交期
   */
  modifyFeedback (data) {
    return request({
      url: '/v1/order/modify/feedback',
      method: 'post',
      data
    })
  },

  /**
   * 更新价格/及校验库存
   */
  queryPrice (params, data) {
    return request({
      url: '/v1/order/query/item/info',
      method: 'post',
      params,
      data: Object.assign(data, {noQs: true}),
      _silent: true,
    })
  },

  /**
   * 修改订单
   */
  modify (data) {
    data.noQs = true
    return request({
      url: '/v1/order/modify/manager',
      method: 'post',
      data
    })
  },

  /**
   * 记录预付款
   */
  markPayFront (data) {
    return request({
      url: '/v1/order/pay/manager',
      method: 'post',
      data
    })
  },

  /**
   * 记录付尾款
   */
  markPayRest (data) {
    return request({
      url: '/v1/order/finalPay/manager',
      method: 'post',
      data
    })
  },

  /**
   * 记录付款
   */
  markPaid (data) {
    return request({
      url: '/v1/order/pay/manager',
      method: 'post',
      data
    })
  },

  /**
   * 完成订单
   */
  finish (data) {
    return request({
      url: '/v1/order/finish/manager',
      method: 'post',
      data
    })
  },

  /**
   * 完成子订单
   */
  subfinish (data) {
    return request({
      url: '/v2/merchant/order/finish/manager',
      method: 'post',
      data
    })
  },

  /**
   * 订单开发票
   */
  receipt (data) {
    return request({
      url: '/v1/order/receipt/manager',
      method: 'post',
      data
    })
  }, 

  /**
   * 现金支付
   */
  payCash (data) {
    return request({
      url: '/v1/order/pay/cash/manager',
      method: 'post',
      data
    })
  }, 

  /**
   * 发货
   */
  shipped (data) {
    return request({
      url: '/v1/order/shipped/manager',
      method: 'post',
      data
    })
  }, 

  /**
   * 取消订单
   */
  cancel (data) {
    return request({
      url: '/v1/order/cancel/manager',
      method: 'post',
      data
    })
  }, 

  /**
   * 同意退款
   */
  refundAgree (data) {
    return request({
      url: '/v1/order/refund/success/manager',
      method: 'post',
      data
    })
  }, 

    /**
   * 拒绝退款
   */
  refundRefuse (data) {
    return request({
      url: '/v1/order/refund/failed/manager',
      method: 'post',
      data
    })
  }, 

  /**
   * 子订单列表
   * @param {*} params 
   */
  getSubOrderList(params){
    return request({
      url: '/v1/order/subOrderList/manager',
      params
    })
  },

   /**
   * 拒收
   */
  reject (data) {
    return request({
      url: '/v2/order/reject/manager',
      method: 'post',
      data
    })
  },
   /**
   * 订单支付凭证上传
   */
  orderpayreceipt (data) {
    return request({
      url: '/v1/order/pay/receipt',
      method: 'post',
      data
    })
  },
}


/**
 * @description [ catalog ] 目录
 */
export const catalogService = {

  type: 'THREE_LEVEL_CATEGORY',
  /**
   * 查询
   */
  queryAvailableNode (){
    return request({
      url: '/v1/catalog/manager',
      params: {type: this.type, status: 'Y'}
    })
  },
  /**
   * 查询单品
   */
  queryProductItem (params) {
    return request({
      url: '/v1/catalog/query/productItem/manager',
      params
    })
  },
  /**
   * 查询目录下的商品, catalogId
   */
  queryProduct (params) {
    return request({
      url: '/v2/catalog/productList/manager',
      params
    })
  },

  /**
   * 查询目录可添加的商品
   */
  getAvailableProductList (params) {
    if(!params.rowsize) {
      params.rowsize = 10
    }
    return request({
      url: '/v2/catalog/availableProductList/manager',
      params
    })
  },

  /**
   * 查询目录可添加的商品
   */
  addProductToCatalog (productId, catalogId, sort) {
    let data = {
      productIdList: productId,
      catalogId,
      sort
    }
    return request({
      url: '/v2/catalog/three/addProduct',
      method: 'post',
      data
    })
  },

  /**
   * 修改商品的排序等
   * required: productId, catalogId
   * sort,price,originalPrice,stock
   */
  modifyCatalogProductInfo (data) {
    return request({
      url: '/v2/catalog/three/product/modifySort',
      method: 'post',
      data
    })
  },

  /**
   * 查询目录可添加的商品
   */
  removeProductFromCatalog (productId, catalogId) {
    let data = {
      productIdList: productId,
      catalogId
    }
    return request({
      url: '/v2/catalog/three/delProduct',
      method: 'post',
      data
    })
  },
  /**
   * 查询广告
   */
  // queryAdvert (params) {
  //   return request({s
  //     url: '/v1/catalog/advert/manager',
  //     params
  //   })
  // },

  /**
   * 添加单品
   */
  addProductItem (data) {
    return request({
      url: '/v1/catalog/add/productItem/manager',
      method: 'post',
      data
    })
  },

  /**
   * 删除单品
   */
  removeProductItem (data) {
    return request({
      url: '/v1/catalog/remove/productItem/manager',
      method: 'post',
      data
    })
  },

  /**
   * 修改单品排序
   */
  modifyProductItemSort (data) {
    return request({
      url: '/v1/catalog/sort/productItem/manager',
      method: 'post',
      data
    })
  },

  /**
   * 单品是否在APP中显示
   */
  brief (data) {
    return request({
      url: '/v1/catalog/brief/manager',
      method: 'post',
      data
    })
  },

  /**
   * 查询广告
   */
  getAdvertList (catalogId) {
    return request({
      url: '/v1/catalog/advert/manager',
      params: {id: catalogId}
    })
  },

  /**
   * 添加广告
   */
  addAdvert (data) {
    return request({
      url: '/v1/catalog/advert/manager',
      method: 'post',
      data
    })
  },

  /**
   * 添加广告
   */
  deleteAdvert (catalogAdvertId) {
    return request({
      url: '/v1/catalog/advert/manager/' + catalogAdvertId,
      method: 'delete'
    })
  },



  /**
   * 查询
   */
  queryAll (){
    return request({
      url: '/v1/catalog/manager',
      params: {type: this.type}
    })
  },
  /**
   * 查询
   */
  query (id){
    return request({
      url: '/v1/catalog/manager/'+id
    })
  },
  /**
   * 添加商品类目
   * **/
  add (data) {
    data.catalogType = this.type
    if(null == data.show) {
      data.show = true
    }
    return request({
      url: '/v1/catalog/manager',
      method: 'post',
      data
    })
  },
    /**
   * 删除商品类目
   * **/
  delete (id) {
    return request({
      url: '/v1/catalog/manager/' + id,
      method: 'delete',
    })
  },

  /**
   * 修改商品类目
   * **/
  modify (data) {
    if(null == data.show) {
      data.show = true
    }
    return request({
      url: '/v1/catalog/manager',
      method: 'put',
      data
    })
  },
}

/**
 * @description [ catalog ] 商家外部目录(店铺)
 */
export const catalogMerchantService = {

  type: 'MERCHANT',
  /**
   * 查询单品
   */
  queryMerchantItem (params) {
    return request({
      url: '/v1/catalog/query/productItem/manager',
      params
    })
  },
  /**
   * 查询目录下的商品, catalogId
   */
  queryMerchant (params) {
    return request({
      url: '/v1/catalog/query/merchant',
      params
    })
  },
  /**
   * 查询目录下的商品, catalogId
   */
  catalogmodifySort (data) {
    return request({
      url: '/v1/catalog/modifySort/merchant',
      method: 'post',
      data
    })
  },

  /**
   * 查询目录可添加的商品
   */
  getAvailableMerchantList (params) {
    if(!params.rowsize) {
      params.rowsize = 10
    }
    return request({
      url: '/v1/catalog/query/available/merchant',
      params
    })
  },

  /**
   * 查询目录可添加的商品
   */
  addMerchantToCatalog (merchantIdList, catalogId, sort) {
    let data = {
      id: catalogId,
      merchantIdList
    }
    return request({
      url: '/v1/catalog/add/merchant',
      method: 'post',
      data
    })
  },

  /**
   * 查询目录可添加的商品
   */
  removeMerchantFromCatalog (merchantIdList, catalogId) {
    let data = {
      id: catalogId,
      merchantIdList
    }
    return request({
      url: '/v1/catalog/remove/merchant',
      method: 'post',
      data
    })
  },
  /**
   * 查询目录可添加的商品
   */
  removeMerchantFromCatalogcope (data) {
    return request({
      url: '/v1/catalog/remove/merchant',
      method: 'post',
      data
    })
  },
  /**
   * 查询广告
   */
  getAdvertList (catalogId) {
    return request({
      url: '/v1/catalog/advert/manager',
      params: {id: catalogId}
    })
  },

  /**
   * 添加广告
   */
  addAdvert (data) {
    return request({
      url: '/v1/catalog/advert/manager',
      method: 'post',
      data
    })
  },



  /**
   * 查询
   */
  queryAll (){
    return request({
      url: '/v1/catalog/manager',
      params: {type: this.type}
    })
  },
  /**
   * 查询
   */
  query (id){
    return request({
      url: '/v1/catalog/manager/'+id
    })
  },
  /**
   * 添加商品类目
   * **/
  add (data) {
    data.catalogType = this.type
    if(null == data.show) {
      data.show = true
    }
    return request({
      url: '/v1/catalog/manager',
      method: 'post',
      data
    })
  },
    /**
   * 删除商品类目
   * **/
  delete (id) {
    return request({
      url: '/v1/catalog/manager/' + id,
      method: 'delete',
    })
  },

  /**
   * 修改商品类目
   * **/
  modify (data) {
    if(null == data.show) {
      data.show = true
    }
    return request({
      url: '/v1/catalog/manager',
      method: 'put',
      data
    })
  },
}



/**
 * @description [ advert ] 广告
 */
export const advertService = {
  /**
   * 添加广告
   */
  add (data) {
    return request({
      url: '/v1/advert/add/manager',
      method: 'post',
      data
    })
  },

  /**
   * 修改广告
   */
  modify (data) {
    return request({
      url: '/v1/advert/modify/manager',
      method: 'post',
      data
    })
  },


}



/**
 * @description [ h5 ] h5
 */
export const h5Service = {
  /**
   * 添加H5
   */
  add (data) {
    return request({
      url: '/v1/h5Page/manager',
      method: 'post',
      data
    })
  },
  /**
   * 添加H5
   */
  add2 (data) {
    data._silent = true;
    return request({
      url: '/v1/h5Page/manager',
      method: data.id ? 'put' : 'post',
      data,
      headers: { 'content-type': 'application/x-www-form-urlencoded' } 
    })
  },
  /**
   * 修改H5
   */
  modify (data) {
    return request({
      url: '/v1/h5Page/manager',
      method: 'put',
      data
    })
  },

  /**
   * 删除H5
   */
  remove (data) {
    return request({
      url: '/v1/h5Page/manager',
      method: 'delete',
      data
    })
  },

  /**
   * 查询H5
   */
  query (params) {
    return request({
      url: '/v1/h5Page/manager',
      params
    })
  },
	/**
   * 查询H5
   */
  query2 (id) {
    return request({
      url: '/v1/h5Page/manager/' + id,
    })
  },
}



/**
 * @description [ discount ] discount
 */
export const discountService = {

  /**
   * 查询有效的品牌
   */
  queryBrandEffective(params) {
    return request({
      url: '/v1/brand/discount/activity/brand/effective/manager',
      params
    })
  },

  /**
   * 查询活动下的单品
   * @param {*} params 
   */
  queryProductItem (params) {
    return request({
      url: '/v1/brand/discount/activity/productitem/query/activityid/manager',
      params
    })
  },

  /**
   * 查询活动下的商品
   * @param {*} params 
   */
  queryProduct (params) {
    return request({
      url: '/v1/brand/discount/activity/product/query/activityid/manager',
      params
    })
  },

  /**
   * 添加单品
   */
  addProductItem (data) {
    return request({
      url: '/v1/brand/discount/activity/add/productitem/manager',
      method: 'post',
      data
    })
  },

  /**
   * 添加商品
   */
  addProduct (data) {
    return request({
      url: '/v1/brand/discount/activity/add/product/manager',
      method: 'post',
      data
    })
  },

  /**
   * 删除单品
   */
  removeProductItem (data) {
    return request({
      url: '/v1/brand/discount/activity/remove/productitem/manager',
      method: 'post',
      data
    })
  },

  /**
   * 删除商品
   */
  removeProduct (data) {
    return request({
      url: '/v1/brand/discount/activity/remove/product/manager',
      method: 'post',
      data
    })
  },

  /**
   * 单品是否在APP中显示
   */
  isShow (data) {
    return request({
      url: '/v1/brand/discount/activity/show/productitem/manager',
      method: 'post',
      data
    })
  },


  /**
   * 商品是否在APP中显示
   */
  isShowProduct (data) {
    return request({
      url: '/v1/brand/discount/activity/show/product/manager',
      method: 'post',
      data
    })
  },
  /**
   * 修改排序
   * @param {} data 
   */
  modifySort (data) {
    return request({
      url: '/v1/brand/discount/activity/catalog/activity/sort/manager',
      method: 'post',
      data
    })
  },

  /**
   *获取活动的统一折扣设置
   */
  getDiscountActivitySetting (id) {
    return request({
      url: '/v1/brand/discount/activity/activity/setting/' + id,
    })
  },
  /**
   *根据品牌id查询单品
   */
  productbrandId (params) {
    return request({
      url: '/v1/product/item/brandId',
      params
    })
  },
   /**
   *单品禁用
   */
  productdisablemanager (data) {
    return request({
      url: '/v1/product/item/unpublish/manager',
      method: 'post',
      data
    })
  },
   /**
   *单品启用
   */
  productenablemanager (data) {
    return request({
      url: '/v1/product/item/publish/manager',
      method: 'post',
      data
    })
  },
  //品牌修改
	modifydiscount (data) {
	    return request({
	      url: '/v1/brand/discount/activity/brand/manager',
	      method: 'put',
	      data
	    })
	  },
	/**
   	*品牌折扣和新品配置修改
   	*/
  brandconfigmodify (data) {
    return request({
      url: '/v1/brand/discount/activity/brand/config/modify',
      method: 'post',
      data
    })
  },
    /**
   *品牌折扣和新品配置历史记录
   */
  brandconfigrecord (params) {
    return request({
      url: '/v1/brand/discount/activity/brand/config/record',
      params
    })
  },

}




/**
 * @description [ bonus ] 拉新广告
 */
export const bonusService = {
  /**
   * 添加
   */
  add (data) {
    return request({
      url: '/v1/bonusAdvert/add/manager',
      method: 'post',
      data
    })
  },


  /**
   * 删除
   */
  remove (data) {
    return request({
      url: '/v1/bonusAdvert/remove/manager',
      method: 'post',
      data
    })
  },

  /**
   * 查询
   */
  query (params) {
    return request({
      url: '/v1/bonusAdvert/query/manager',
      params
    })
  },

}


/**
 * @description [ user ] 用户
 */
export const userService = {


   /**
   * 修改密码
   */
  getUncheckCount () {
    return request({
      url: '/v1/customer/uncheck/count',
    })
  },

   /**
   * 修改密码
   */
  modifyPassword (userId, passwd) {
    let data = {
      clientId: userId,
      newPassword: passwd
    }
    return request({
      url: '/v1/customer/modifypasswd',
      method: 'post',
      data
    })
  },

  /**
   * 查询
   */
  query (params){
    return request({
      url: '/v1/customer/manager',
      params
    })
  },
  /**
   * 修改用户信息
   */
  addOrModify (data){
    return request({
      url: '/v1/customer/user/manager', // ??????
      method: 'post',
      data
    })
  },
  /**
   * 同意用户加入
   */
  agree (data){
    return request({
      url: '/v1/customer/agree', 
      method: 'post',
      data
    })
  },
  /**
   * 同意用户加入
   */
  refuse (data){
    return request({
      url: '/v1/customer/refused',
      method: 'post',
      data
    })
  },
  /**
   * 修改等级
   */
  modifyLevel (data){
    return request({
      url: '/v1/customer/modify/level/manager',
      method: 'post',
      data
    })
  },
  /**
   * 删除用户
   */
  remove (data){
    return request({
      url: '/v1/customer/remove/manager',
      method: 'post',
      data
    })
  },
  /**
   * 修改用户状态
   */
  modifyStatus (data){
    return request({
      url: '/v1/customer/enabled',
      method: 'post',
      data
    })
  },
  /**
   * 查询
   */
  searchmanager (params){
    return request({
      url: '/v1/customer/search/manager',
      params
    })
  },
  subaccountmanager (params){
    return request({
      url: '/v1/customer/subaccount/manager',
      params
    })
  },
  subaccountadd (data){
    return request({
      url: '/v1/customer/subaccount/manager',
      method: 'post',
      data
    })
  },
  subaccountmodify (data){
    return request({
      url: '/v1/customer/subaccount/manager',
      method: 'put',
      data
    })
  },
  subaccountremove (params){
    return request({
      url: '/v1/customer/subaccount/manager',
      method: 'delete',
      params
    })
  },
  queryprovince (params){
    return request({
      url: '/v1/address/queryprovince',
      params
    })
  },
  querycity (params){
    return request({
      url: '/v1/address/querycity',
      params
    })
  },
  isnameexist (params){
    return request({
      url: '/v1/customer/isnameexist',
      params
    })
  },
  isuserexist (params){
    return request({
      url: '/v1/customer/isuserexist',
      params
    })
  },
}

/**
 * @description [ product ] 商品
 */
export const productService = {
	/**
   * 删除商品
   */
  delete (productId){
    return request({
      url: '/v1/product/manager/' + productId,
      method: 'delete'
    })
  },
  /**
   * 查询
   */
  query (id){
    return request({
      url: '/v1/product/merge/manager/'+id
    })
  },

  /**
   * 重置搜索词库
   */
  resetKeyword (){
    return request({
      url: '/v1/test/search/reset'
    })
  },
  /**
   * 查询品牌列表（下拉框）
   */
  selectbrandList (){
    return request({
      url: '/v1/brand/discount/activity/select/brand/list'
    })
  },
  /**
   * 查询店铺列表（下拉框）
   */
  merchantUsermanager (params){
    return request({
      url: '/v1/merchantList/manager',
      params
    })
  },
  /**
   * 目录列表（下拉框）
   */
  queryproductmanager (params){
    return request({
      url: '/v1/catalog/manager',
      params
    })
  },
   /**
   * 查询制造商
   */
  manufacturerQueryAll (){
    return request({
      url: '/v2/manufacturer/manager'
    })
  },
  /**
   * 新增/修改
   */
  addOrModify (data){
    data.noQs = true
    return request({
      url: '/v1/product/merge/manager',
      method: data.id? 'put' :'post',
      data,
    })
  },
  productvisible (data){
    return request({
      url: '/v1/product/visible',
      method: 'post',
      data
    })
  },
  /**
   * 根据长宽高和重量计算运费
   */
  productitemfreight (data){
  	data.noQs = true
    return request({
      url: '/v1/product/item/freight',
      method: 'post',
      data
    })
  },
  /**
   * 查询商家已添加的推荐商品信息
   */
   recommendproductquery (params){
    return request({
      url: '/v1/recommend/product/query',
      params
    })
  },
  /**
   * 查询可添加到推荐商品的商品列表**/
  recommendproductavailable (params){
    return request({
      url: '/v1/recommend/product/available',
      params
    })
  },
   /**
   * 商家新增推荐商品
   */
  recommendproductadd (data) {
    return request({
      url: '/v1/recommend/product/add',
      method: 'post',
      data
    })
  },
   /**
   * 删除推荐商品
   */
  recommendproductdel (params) {
    return request({
      url: '/v1/recommend/product/del',
      method: 'delete',
      params
    })
  },
  /**
   * 查询品牌列表（下拉框）
   */
  selectbrandListForMerchant (){
    return request({
      url: '/select/brand/list/merchant'
    })
  },
  /**
   * 查询分类列表（下拉框）
   */
  categoryqueryall (){
    return request({
      url: '/select/category/list/merchant'
    })
  },
}



/**
 * @description [ productItem ] 单品
 */
export const productItemService = {

  /**
   * 查询
   */
  query (params){
    return request({
      url: '/v1/product/item/manager',
      params
    })
  },


  /**
   * 上架
   */
  publish (data) {
    return request({
      url: '/v1/product/item/publish/manager',
      method: 'post',
      data
    })
  },

  /**
   * 下架
   */
  unpublish (data) {
    return request({
      url: '/v1/product/item/unpublish/manager',
      method: 'post',
      data
    })
  },

  /**
   * 修改
   */
  modify (data) {
    data.noQs = true
    return request({
      url: '/v1/product/item/manager',
      method: 'put',
      data
    })
  },

  /**
   * 修改价格
   */
  modifyPrice (data) {
    data.noQs = true
    return request({
      url: '/v1/product/item/price',
      method: 'post',
      data
    })
  },

  /**
   * 复制
   */
  copy (data) {
    return request({
      url: '/v1/product/item/copy/manager',
      method: 'post',
      data
    })
  },

  /**
   * 删除
   */
  remove (data) {
    return request({
      url: '/v1/product/item/remove/manager',
      method: 'post',
      data
    })
  },
  /**
   * 删除,不删除sku
   */
  remove2 (data) {
    return request({
      url: '/v2/product/item/Merge/remove/manager',
      method: 'post',
      data
    })
  },
  /**
   * 单品barcode校验
   */
  productbarcodequery (params){
    return request({
      url: '/v1/product/barcode/query',
      params
    })
  },
}




/**
 * @description [ wallet ] 钱包
 */
export const walletService = {
  /**
   * 查询余额
   */
  balance (params) {
    return request({
      url: '/v1/wallet/queryacount/manager',
      params
    })
  },
  /**
   * 查询提现记录
   */
  queryWithdrawal (params){
    return request({
      url: '/v1/wallet/querywithdrawal/manager',
      params
    })
  },
  /**
   * 同意提现
   */
  agreeeWithdrawal (data){
    return request({
      url: '/v1/wallet/agreeewithdrawal/manager',
      method: 'post',
      data
    })
  },
  /**
   * 拒绝提现
   */
  refuseWithdrawal (data){
    return request({
      url: '/v1/wallet/refusewithdrawal/manager',
      method: 'post',
      data
    })
  },
  
  /**
   * 完成提现
   */
  finishWithdrawal (data){
    return request({
      url: '/v1/wallet/finishwithdrawal/manager',
      method: 'post',
      data
    })
  },
  /**
   * 查询提现银行卡信息
   */
  querywithdrawalcard (params){
    return request({
      url: '/v1/wallet/querywithdrawal/card',
      params
    })
  },

}


/**
 * @description [ cache ] 缓存相关
 */
export const cacheService = {
  /**
   * 重置商品缓存
   */
  resetProductCache () {
    return request({
      url: '/v1/sys/product/resetCache/manager',
    })
  },
  /**
   * 重置搜索缓存
   */
  resetSearchCache () {
    return request({
      url: '/v1/sys/search/resetCache/manager',
    })
  },
  /**
   * 清理活动缓存
   */
  activity () {
    return request({
      url: '/v1/activity/refreshqueryall/manager',
    })
  },
  /**
   * 清理轮播图缓存
   */
  carousel () {
    return request({
      url: '/v1/home/cache/remove/manager',
    })
  },
  /**
   * 清理标签缓存
   */
  tag () {
    return request({
      url: '/v1/tag/refreshqueryall/manager',
    })
  },
  /**
   * 清理分类缓存
   */
  category () {
    return request({
      url: '/v1/category/refreshcategory/manager',
    })
  },
  /**
   * 清理新分类缓存
   */
  newCategory () {
    return request({
      url: '/v1/category/refreshnewcategory/manager',
    })
  },
  /**
   * 清理h5首页缓存
   */
  removemanager () {
    return request({
      url: '/v1/h5/home/cache/remove/manager',
    })
  },
}




/**
 * @description [ sys ] 系统信息
 */
export const sysInfoService = {
  /**
   * 获取系统信息
   */
  get () {
    return request({
      url: '/sys/info'
    })
  }
}

/**
 * @description [ sys ] 菜单和路由相关
 */
export const sysMenuService = {
  /**
   * 获取菜单
   */
  getNav () {
    return request({
      url: '/v1/menu/nav/list/manager'
    })
  },
  /**
   * 获取权限
   */
  getPermissions () {
    return request({
      url: '/sys/menu/permissions'
    })
  }
}

/**
 * @description [ sys ] 用户相关
 */
export const sysUserService = {
  /**
   * 获取用户信息
   */
  getInfo () {
    return cookieGet("user");
  },
  updatePassword (data) {
    return request({
      url: '/v1/customer/changepasswd/manager',
      method: 'post',
      data
    })
  }
}

 /**
 * @description [ member ] 会员管理
 */
export const memberService = {

  /**
   * 用户列表
   */
  getUserList (params){
    return request({
      url: '/v1/member/listPage',
      params
    })
  },

  /**
   * 获取佣金记录
   */
  getRewardRecord (params) {
    return request({
      url: '/v1/member/reward/record',
      params
    })
  },

  /**
   * 解绑
   */
  unbinding (data) {
    return request({
      url: '/v1/member/untie',
      method: 'post',
      data
    })
  },

  /**
   * 获取奖励提示
   */
  getRewardInfo () {
    return request({
      url: '/v1/reward/prompt/info'
    })
  },

  /**
   * 修改奖励提示
   */
  modifyRewardInfo (data) {
    return request({
      url: '/v1/reward/prompt/modify',
      method: 'post',
      data
    })
  },

  /**
   * 修改活动字典(多语言)
   */
  modifyLanguageInfo (data) {
    return request({
      url: '/v1/multitext/manager',
      method: 'put',
      data
    })
  },
  /**
   * 新增文本
   */
  addLanguageInfo (data) {
    return request({
      url: '/v1/multitext/manager',
      method: 'post',
      data
    })
  },
  
}

 /**
 * @description [ reward ] 拉新金额管理
 */
export const rewardService = {

  /**
   * 获取奖励详情
   */
  getPullNewData () {
    return request({
      url: '/v1/reward/pullNew/manager',
    })
  },

  /**
   * 统计数据
   */
  getPullNewStatistics () {
    return request({
      url: '/v1/reward/pullNew/statistics',
    })
  },

  /**
   * 当前奖励详情
   */
  getCurrentDetails (params) {
    return request({
      url: '/v1/reward/pullNew/reward/details',
      params
    })
  },

  /**
   * 奖励规则修改
   */
  updatePullNewManager (data) {
    return request({
      url: '/v1/reward/pullNew/update/manager',
      method: 'post',
      data
    })
  },

  /**
   * 获取奖励详情
   */
  getPastRecord () {
    return request({
      url: '/v1/reward/pullNew/ruleUpdatePastRecord',
    })
  },
}

/**
 * @description [ buyfree ] buyfree管理
 */
export const buyfreeService = {

  /**
   * 获取单品列表
   */
  getProductItemList () {
    return request({
      url: '/v1/brand/discount/activity/productitem/query/activityid/manager',
    })
  },

  /**
   * 下架buyfree活动
   */
  removeBuyfree (data) {
    return request({
      url: '/v1/marketing/buyfree/remove/manager',
      method: 'post',
      data
    })
  },

  /**
   * 查询单个活动详情
   */
  getBuyfreeDetails (params) {
    return request({
      url: '/v1/marketing/buyfree/detail/manager',
      params
    })
  },

  /**
   * 查询单个活动详情用户参与列表
   */
  getClientUserList (params) {
    return request({
      url: '/v1/marketing/buyfree/clientuser/list/manager',
      params
    })
  },

  /**
   * 查询单个活动详情单个用户拉新列表
   */
  getUserPullNewList (params) {
    return request({
      url: '/v1/marketing/buyfree/pulluser/list/manager',
      params
    })
  }
}

/**
 * @description [ video ] video管理
 */
export const videoService = {

  /**
   * 删除video
   */
  remove (params) {
    return request({
      url: '/v1/carouselVideo/remove/manager/',
      method: 'delete',
      params
    })
  },

}

/**
 * @description [ carousel ] 轮播图管理
 */
export const carouselService = {

  /**
   * 删除轮播图
   */
  remove (params) {
    return request({
      url: '/v1/discount/carousel/remove/manager',
      method: 'delete',
      params
    })
  },

  /**
   * 获取轮播图列表
   */
  getList () {
    return request({
      url: '/v1/discount/catalog/carousel/manager',
    })
  },

}

/**
 * @description [ tag ] 首页标签管理
 */
export const tagService = {

  /**
   * 获取标签列表
   */
  getList (params) {
    return request({
      url: '/v1/discount/tags/page',
      params
    })
  },

  /**
  * 删除单个标签
  */
  remove (params) {
    return request({
      url: '/v1/discount/tags/remove',
      params
    })
  },

  /**
   * 获取单品列表
   */
  getProductItemList () {
    return request({
      url: '/v1/brand/discount/activity/productitem/query/activityid/manager',
    })
  },

  /**
   * 获取所有商品列表
   */
  getAllProductList () {
    return request({
      url: '/v1/brand/discount/activity/product/query/all/manager',
    })
  },

  /**
   * 获取标签内的已添加内容
   */
  getContentInfoList (params) {
    return request({
      url: '/v1/discount/tags/monopoly/item/info',
      params
    })
  },

  /**
   * 获取标签内的未添加单品
   */
  getNoAddProductItemInfoList (params) {
    return request({
      url: '/v1/discount/tags/product/manager',
      params
    })
  },


  /**
   * 移除已添加的单品
   */
  removeProductItem (params) {
    return request({
      url: '/v1/discount/tags/monopoly/remove',
      method: 'delete',
      params
    })
  },
  /**
   * 修改已添加内容的排序或上下架
   */
  modifyContentSortOrStatus (data) {
    return request({
      url: '/v1/discount/tags/monopoly/item/sort/modify',
      method: 'put',
      data
    })
  },

  /**
   * 查看已添加的热销内的单品
   */
  getHotsaleProductItemList(params){
    return request({
      url: '/v1/discount/monopoly/item/info/',
      params
    })
  }
}

/**
 * @description [ specialactivity ] 品牌专场管理
 */
export const specialactivityService = {
  /**
   * 获取所有活动列表
   */
  queryActivityList (params) {
    return request({
      url: '/v1/brand/discount/activity/manager',
      params
    })
  },

  /**
   * 获取所有的标签列表
   */
  queryTagList (params) {
    return request({
      url: '/v1/discount/tags/page',
      params
    })
  },

}

/**
 * @description [ homepage ] 首页管理
 */
export const homepageService = {

    /**
   * 修改首页已添加内容的排序或上下架
   */
  modifyContentSortOrStatus (data) {
    return request({
      url: '/v1/discount/homepage/monopoly/item/sort/modify',
      method: 'put',
      data
    })
  },

  /**
   * 移除首页内容
   */
  removeContent (params) {
    return request({
      url: '/v1/discount/homepage/monopoly/remove',
      method: 'delete',
      params
    })
  },


  /**
   * 修改热销时批量移除单品
   */
  removeProductItem(params){
    return request({
      url: '/v1/discount/hotsales/item/remove',
      method: 'delete',
      params
    })
  },

  /**
   * 修改热秒活动
   */
  modifyHotsale(data) {
    return request({
      url: '/v1/discount/hotsales/modify',
      method: 'put',
      data
    })
  },

}

/**
 * @description [ merchant ] 商家管理管理
 */
export const merchantService = {
  /**
   * 获取所有商家列表
   */
  getMerchantList (params) {
    if (!params) {
      params = {}
    }
    if (!params.beginpage) {
      params.beginpage = 1
    }
    if (!params.rowsize) {
      params.rowsize = 0
    }
    return request({
      url: '/v1/merchantList/manager',
      params
    })
  },


  /**
   * 登录
   */
  addMerchantUser (data) {
    return request({
      url: '/v1/addMerchantUser/manager',
      method: 'post',
      data
    })
  }

}
/**
 * @description [ systemManagement ] 系统管理
 */
export const systemManagement = {
  /**
   * 添加APK版本
   * **/
  addApkUpdate (data) {
    return request({
      url: '/v1/upload/addApkUpdate',
      method: 'post',
      data
    })
  },
  /**
   * 查询AKP列表
   */
  apkManager (params) {
    return request({
      url: '/v1/apk/manager',
      params
    })
  },
  /**
   * 修改强制更新状态
   * **/
  apkforceupdate (data) {
    return request({
      url: '/v1/apk/modify/forceupdate/manager',
      method: 'post',
      data
    })
  },
  /**
   * 修改强制更新状态
   * **/
  apkforceupdate (data) {
    return request({
      url: '/v1/apk/modify/forceupdate/manager',
      method: 'post',
      data
    })
  },
  /**
   * 删除版本
   */
  remove (params) {
    return request({
      url: '/v1/apk/remove/manager',
      method: 'delete',
      params
    })
  },
}
/**
 * 类目管理
 */
export const categorynewapi = {
  /**
   * 删除商品类目
   * **/
  categoryremove (data) {
    return request({
      url: '/v1/category/remove/manager',
      method: 'post',
      data
    })
  },
  /**
   * 修改商品类目
   * **/
  categorymodify (data) {
    return request({
      url: '/v1/category/modify/manager',
      method: 'post',
      data
    })
  },
  
}
/**
 * 目录管理
 */
export const categoryService = { 
  type: 'CATEGORY',
  /**
   * 查询
   */
  queryAvailableNode (){
    return request({
      url: '/v1/catalog/manager',
      params: {type: this.type, status: 'Y'}
    })
  },
  /**
   * 查询目录下的商品列表
   */
  queryproductmanager (params) {
    return request({
      url: '/v1/catalog/query/product/manager',
      params
    })
  },
   /**
   * 从目录移除商品
   * **/
  removeproductmanager (data) {
    return request({
      url: '/v1/catalog/remove/product/manager',
      method: 'post',
      data
    })
  },
   /**
   * 向目录添加商品
   * **/
  addproductmanager (data) {
    return request({
      url: '/v1/catalog/add/product/manager',
      method: 'post',
      data
    })
  },
  /**
   * 查询category列表（下拉框）
   */
  queryAll (){
    return request({
      url: '/v1/category/queryall/manager'
    })
  },
}

/**
 * 报表
 */
export const reportService = { 
  /**
   * 查询日报表
   */
  queryDailyData (params) {
    return request({
      url: '/v1/statistic/daily/report',
      params
    })
  },
}
/**
 * 消息
 */
export const messages = {
  /**
   * 删除消息
   * **/
  remove (data) {
    return request({
      url: '/v1/message/manager/remove',
      method: 'post',
      data
    })
  },
  /**
   * 禁用消息
   * **/
  disable (data) {
    return request({
      url: '/v1/message/manager/disable',
      method: 'post',
      data
    })
  },
   /**
   * 启用消息
   * **/
  enable (data) {
    return request({
      url: '/v1/message/manager/enable',
      method: 'post',
      data
    })
  },
  /**
   * GET 查询消息各状态数量
   */
  statusCount (){
    return request({
      url: '/v1/message/manager/statusCount'
    })
  },
}
/**
 * @description [ merchantCategory ] 多商家分类管理
 */
export const merchantCategoryService = {
  /**
   * 获取当前商家的分类列表
   */
  queryCategoryList (params) {
    return request({
      url: '/v2/catalog/list',
      params
    })
  },

  /**
   * 获取当前商家的分类里面的商品列表
   */
  queryCategoryProductItemList (params) {
    return request({
      url: '/v2/catalog/productList/merchant',
      params
    })
  },

  /**
   * 添加商品到分组(商户)
   */
  addProductItem (data) {
    return request({
      url: '/v2/catalog/addProduct/merchant',
      method: 'post',
      data
    })
  },

  /**
   * 删除分组内的商品
   */
  removeProductItem (data) {
    return request({
      url: '/v2/catalog/delProduct/merchant',
      method: 'post',
      data
    })
  },
   /**
   * 修改分组里商品的排序(商户)
   */
  productmodifySort (data) {
    return request({
      url: '/v2/catalog/product/modify/merchant',
      method: 'post',
      data
    })
  },
}
export const languageService = {
  addOrModify(data) {
    return request({
      url: '/v1/multitext/merchant',
      method: data.id ? 'put' : 'post',
      data
    })
  }
}
export const reportForm = {
  partnernamelist(params) {
    return request({
      url: '/v1/partner/name/list',
      params
    })
  }
}